
import React from "react";
import { User } from "@/models/user";

interface DashboardHeaderProps {
  user: User;
  title: string;
  subtitle?: string;
}

export function DashboardHeader({ user, title, subtitle }: DashboardHeaderProps) {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">{title}</h1>
          {subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-4">
          <div className="text-right">
            <p className="text-sm font-medium">{user.name}</p>
            <p className="text-xs text-muted-foreground">{user.email}</p>
          </div>
          <div className="flex h-10 w-10 rounded-full bg-purple-100 items-center justify-center">
            <span className="text-sm font-medium text-purple-700">
              {user.name.charAt(0).toUpperCase()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
